import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';

import { ReportEndpoint } from './reportendpoint.service';
import { RegulatoryItemDto } from '../models/regulatoryitem.model';
import { DepartmentDto } from '../models/Department.model';
import { AgencyDto } from '../models/Agency.model';
import { LegislationDto } from '../models/Legislation.model';
import { RegulatoryUpdateDto } from '../models/RegulatoryUpdate.model';
import { RegulatoryUpdateTypeVldDto } from '../models/RegulatoryUpdateTypeVld.model';
import { RegulatoryItemTypeVldDto } from '../models/RegulatoryItemTypeVld.model';
import { ExternalDocumentDto } from '../models/ExternalDocument.model';
import { BusinessRuleMessage } from '../models/BusinessRuleMessage.model';


@Injectable()

export class ReportService {
  constructor(private router: Router, private reportEndpoint: ReportEndpoint) {
  }

  getPdfRegulatoryItemCounts(departmentId?: string, legislationId?: string, agencyId?: string, userProfileId?: string, reportName?: string) {
    return this.reportEndpoint.getPdfRegulatoryItemCounts<Blob>(departmentId, legislationId, agencyId, userProfileId, reportName);
  }

  getPdfRegulatoryItemCountsUrl(departmentId?: string, legislationId?: string, agencyId?: string, userProfileId?: string, reportName?: string): string {
    return this.reportEndpoint.getPdfRegulatoryItemCountsUrl<string>(departmentId, legislationId, agencyId, userProfileId, reportName);
  }

  getExcelRegulatoryItemCounts(departmentId?: string, legislationId?: string, agencyId?: string, userProfileId?: string, reportName?: string) {
    return this.reportEndpoint.getExcelRegulatoryItemCounts<Blob>(departmentId, legislationId, agencyId, userProfileId, reportName);
  }

  getPdfMinistryOverview(departmentId?: string, userProfileId?: string) {
    return this.reportEndpoint.getPdfMinistryOverview<Blob>(departmentId, userProfileId);
  }

  getPdfMinistryOverviewUrl(departmentId?: string, userProfileId?: string): string {
    return this.reportEndpoint.getPdfMinistryOverviewUrl<string>(departmentId, userProfileId);
  }

  getPdfPermitQuarterly(departmentId?: string, userProfileId?: string) {
    return this.reportEndpoint.getPdfPermitQuarterly<Blob>(departmentId, userProfileId);
  }

  getPdfPermitQuarterlyUrl(departmentId?: string, userProfileId?: string): string {
    return this.reportEndpoint.getPdfPermitQuarterlyUrl<string>(departmentId, userProfileId);
  }

  getExcelPermitQuarterly(departmentId?: string, userProfileId?: string) {
    return this.reportEndpoint.getExcelPermitQuarterly<Blob>(departmentId, userProfileId);
  }

  getExcelMinistryOverview(departmentId?: string, userProfileId?: string) {
    return this.reportEndpoint.getExcelMinistryOverview<Blob>(departmentId, userProfileId);
  }

  getPdfRegulatoryUpdateChanges(departmentId?: string, agencyId?: string, dateType?: string, startDate?: string, endDate?: string, userProfileId?: string, reportName?: string) {
    return this.reportEndpoint.getPdfRegulatoryUpdateChanges<Blob>(departmentId, agencyId, dateType, startDate, endDate, userProfileId, reportName);
  }

  getPdfRegulatoryUpdateChangesUrl(departmentId?: string, agencyId?: string, dateType?: string, startDate?: string, endDate?: string, userProfileId?: string, reportName?: string): string {
    return this.reportEndpoint.getPdfRegulatoryUpdateChangesUrl<string>(departmentId, agencyId, dateType, startDate, endDate, userProfileId, reportName);
  }

  getExcelRegulatoryUpdateChanges(departmentId?: string, agencyId?: string, dateType?: string, startDate?: string, endDate?: string, userProfileId?: string, reportName?: string) {
    return this.reportEndpoint.getExcelRegulatoryUpdateChanges<Blob>(departmentId, agencyId, dateType, startDate, endDate, userProfileId, reportName);
  }

  getPdfAnnualPlanMinistryReport(departmentId?: string, annualPlanYearVldID?: string) {
    return this.reportEndpoint.getPdfAnnualPlanMinistryReport<Blob>(departmentId, annualPlanYearVldID);
  }

  getPdfAnnualPlanMinistryReportUrl(departmentId?: string, annualPlanYearVldID?: string): string {
    return this.reportEndpoint.getPdfAnnualPlanMinistryReportUrl<string>(departmentId, annualPlanYearVldID);
  }


  getExcelAnnualPlanMinistryReport(departmentId?: string, annualPlanYearVldID?: string) {
    return this.reportEndpoint.getExcelAnnualPlanMinistryReport<Blob>(departmentId, annualPlanYearVldID);
  }

  getPdfAgencyOverview(agencyId?: string, userProfileId?: string) {
    return this.reportEndpoint.getPdfAgencyOverview<Blob>(agencyId, userProfileId);
  }

  getPdfAgencyOverviewUrl(agencyId?: string, userProfileId?: string): string {
    return this.reportEndpoint.getPdfAgencyOverviewUrl<string>(agencyId, userProfileId);
  }

  getExcelAgencyOverview(agencyId?: string, userProfileId?: string) {
    return this.reportEndpoint.getExcelAgencyOverview<Blob>(agencyId, userProfileId);
  }

}
